import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/cn';

interface WordmarkProps {
  size?: 'sm' | 'md' | 'lg';
  /** The 14s spin is the brand's idle motion; off under reduced motion via CSS. */
  spin?: boolean;
  className?: string;
}

const SIZE = {
  sm: { logo: 22, text: 'text-[15px]' },
  md: { logo: 23, text: 'text-base' },
  lg: { logo: 26, text: 'text-[17px]' },
} satisfies Record<NonNullable<WordmarkProps['size']>, { logo: number; text: string }>;

/** Logo plus the uppercase AEON wordmark, linking home. */
export function Wordmark({ size = 'md', spin = true, className }: WordmarkProps) {
  const { logo, text } = SIZE[size];
  return (
    <Link to="/" className={cn('flex items-center gap-[10px] text-ink hover:text-ink', className)}>
      <img src="/logo.svg" alt="Aeon Karaoke" width={logo} height={logo} className={cn(spin && 'logo-spin-slow')} />
      <span className={cn('font-semibold uppercase tracking-[0.12em]', text)}>Aeon</span>
    </Link>
  );
}
